/* hs-eslint ignored failing-rules */
/* eslint-disable @typescript-eslint/no-floating-promises */

// @ts-expect-error untyped
import { makeAsyncComponent } from 'ContentEditorUI/components/shared/makeAsyncUtils';
import ModalDataTypes from 'ContentComponents/constants/ModalDataTypes';
import { MODAL_TYPES } from 'ContentEditorUI/lib/modalConstants';
import { useCallback, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
// @ts-expect-error untyped
import { getContent } from 'ContentEditorUI/redux/selectors/contentSchemaSelectors';
import { getSiteSettings } from 'ContentEditorUI/redux/selectors/siteSettingsSelectors';
import { createSelector } from 'reselect';
import { Map as ImmutableMap, fromJS } from 'immutable';
// @ts-expect-error untyped
import { closeModal } from 'ContentEditorUI/redux/actions/appActions';
import useContentModalActions from 'ContentEditorUI/hooks/useContentModalActions';
import redirectToNewUrl from 'ContentEditorUI/utils/contentManagementPanel/redirectToNewUrl';
import ContentRoutes from 'ContentUtils/Routes';
import CreatePageModal from 'ContentEditorUI/components/modals/contentManagement/CreatePageModal';
import { ContentCategories } from 'FileManagerCore/Constants';
import { ContentTypes } from 'ContentComponents/constants/ContentActionModalContentTypes';
import { getIsSitePage } from 'ContentEditorUI/utils/contentManagementPanel/contentTableUtils';
import { getHasAutotranslateAccess } from 'ContentEditorUI/redux/selectors/authSelectors';
import UsageTracker from 'ContentEditorUI/utils/UsageTracker';
import { jsx as _jsx } from "react/jsx-runtime";
const AsyncDeletePageModal = makeAsyncComponent(() => import( /* webpackChunkName: 'DeletePageModal' */'./DeletePageModal'));
const AsyncClonePageModal = makeAsyncComponent(() => import( /* webpackChunkName: 'ClonePageModal' */'./ClonePageModal'));
const AsyncCreatePageTranslationModal = makeAsyncComponent(() => import( /* webpackChunkName: 'PageCreateMlangVariantModal' */'ContentComponents/components/contentActionModals/TranslationModal').then(result => result.CreateTranslationModal));
const AsyncTranslateContentActionModal = makeAsyncComponent(() => import( /* webpackChunkName: 'TranslateContentActionModal' */'ContentEditorUI/components/modals/TranslateContentActionModal'));
const AsyncContentRemixModal = makeAsyncComponent(() => import( /* webpackChunkName: 'ContentRemixModal' */'ContentComponents/components/contentActionModals/ContentRemixModal').then(result => result.default));
const CreatePageModalWrapper = ({
  closeModal: handleCloseModal
}) => {
  const content = useSelector(getContent);
  const contentTypeId = content.categoryId;
  const domainName = content.domain || content.resolvedDomain;
  return /*#__PURE__*/_jsx(CreatePageModal, {
    contentTypeId: contentTypeId,
    domainName: domainName,
    closeModal: handleCloseModal
  });
};
const selectModalRelevantEntities = createSelector(getContent, content => {
  return ImmutableMap([[content.id, fromJS(content)]]);
});
const getEditorUrlWithQueryParamsAfterCreatingTranslation = ({
  editUrl,
  newMlangVariantFromMasterLang
}) => {
  const queryParams = ['redirectFromMultiLangVariationCreation=true'];
  if (newMlangVariantFromMasterLang) {
    queryParams.push('newMlangVariantFromMasterLang=true');
  }
  return `${editUrl}?${queryParams.join('&')}`;
};
const ModalMap = {
  [MODAL_TYPES.CREATE_MLANG_VARIANT]: AsyncCreatePageTranslationModal,
  [MODAL_TYPES.CONTENT_REMIX]: AsyncContentRemixModal,
  [MODAL_TYPES.TRANSLATE_CONTENT_ACTION_MODAL]: AsyncTranslateContentActionModal,
  [MODAL_TYPES.CREATE_CONTENT_MODAL]: CreatePageModalWrapper,
  [MODAL_TYPES.CLONE_CONTENT_MODAL]: AsyncClonePageModal,
  [MODAL_TYPES.DELETE_MODAL]: AsyncDeletePageModal
};
const noop = () => {};
const useModalActions = () => {
  const dispatch = useDispatch();
  const isSitePage = useSelector(getIsSitePage);
  const onDeletePage = useCallback(content => {
    let categoryId;
    if (content) {
      categoryId = content.categoryId;
    } else {
      categoryId = isSitePage ? ContentCategories.get(ContentTypes.SITE_PAGE) : ContentCategories.get(ContentTypes.LANDING_PAGE);
    }
    redirectToNewUrl(ContentRoutes.dashboard(categoryId));
  }, [isSitePage]);
  const onCreateTranslationVariation = useCallback((content, opts) => {
    const {
      newMlangVariantFromMasterLang
    } = opts;
    const contentEditRoute = ContentRoutes.edit(content.id, content.categoryId);
    const redirectUrl = getEditorUrlWithQueryParamsAfterCreatingTranslation({
      editUrl: contentEditRoute,
      newMlangVariantFromMasterLang
    });
    redirectToNewUrl(redirectUrl);
  }, []);
  const onCreateTranslationVariationError = useCallback(() => {
    dispatch(closeModal());
  }, [dispatch]);
  const {
    deleteContent,
    cloneContent,
    createTranslationVariation
  } = useContentModalActions(onDeletePage, noop, onCreateTranslationVariation, onCreateTranslationVariationError);
  const actions = useMemo(() => ({
    deleteContent: page => {
      deleteContent(page);
    },
    clone: (page, cloneName) => {
      cloneContent(page, cloneName);
    },
    closeModal: () => dispatch(closeModal()),
    createTranslationVariation: (pagesToTranslate, opts) => {
      const page = pagesToTranslate.first().toJS();
      createTranslationVariation(page, opts);
    }
  }), [deleteContent, cloneContent, createTranslationVariation, dispatch]);
  return actions;
};
const PageOperationsModalSwitch = ({
  openModalName
}) => {
  const modalActions = useModalActions();
  const modalRelevantEntities = useSelector(selectModalRelevantEntities);
  const siteSettings = useSelector(getSiteSettings);
  const hasAutotranslateAccess = useSelector(getHasAutotranslateAccess);
  if (!openModalName || !ModalMap[openModalName]) {
    return null;
  }
  const PageOperationsModal = ModalMap[openModalName];
  return /*#__PURE__*/_jsx(PageOperationsModal, Object.assign({}, modalActions, {
    modalRelevantEntities: modalRelevantEntities,
    managementDataType: "pages",
    modalDataType: ModalDataTypes.PAGES,
    openModalName: openModalName,
    portalSettings: siteSettings,
    translationModalErrors: [],
    usageTracker: UsageTracker.tracker,
    portalHasAutotranslateAccess: hasAutotranslateAccess
  }));
};
export default PageOperationsModalSwitch;